import Login from "../../components/auth/login";

export default Login;

